import { render, staticRenderFns } from "./SandboxPage.vue?vue&type=template&id=0c340518&"
import script from "./SandboxPage.vue?vue&type=script&lang=js&"
export * from "./SandboxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports